import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { Injectable } from '@angular/core';
import { IDeployPriorityAtomicRule } from '../interfaces/deploy-priority/deploy-priority-atomic-rule';
import { EditService } from './edit.service';
import { IBaseFilter } from '../interfaces/base-filter';

@Injectable({
  providedIn: 'root',
})
export class DeployPriorityAtomicRulesService extends EditService<
  IDeployPriorityAtomicRule,
  IBaseFilter
> {
  url = '/api/DeployPriorityAtomicRule';

  entityTitle = 'Deploy Priority Atomic Rule';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
